import { render, staticRenderFns } from "./DocModal.vue?vue&type=template&id=07abe74f"
import script from "./DocModal.vue?vue&type=script&lang=js"
export * from "./DocModal.vue?vue&type=script&lang=js"
import style0 from "./DocModal.vue?vue&type=style&index=0&id=07abe74f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports